import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";

import AddProject from "./pages/AddProject";
import LabelComponent from "./pages/lableView/LabelView";
import SegmentComponent from "./pages/segmentView/SegmentView";
import OCRComponent from "./pages/ocr/OCRView";
import ProjectOverview from "./pages/ProjectOverview";
import AllProjects from "./pages/AllProjects";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { API_BASE_URL } from "./utils/crudFunctions";
function App() {
  const [projectName, setProjectName] = useState(null);



  // -------------------------

  return (
    <div className="min-h-screen bg-gray-50">
      <Router>
        <Navbar projectName={projectName} />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/login" element={<Login />} />
          <Route
            path="/add-project"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <AddProject
                  setProjectName={setProjectName}
                  projectName={projectName}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:userName/:projectName"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <ProjectOverview setProjectName={setProjectName} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:userName/:projectName/label/:index"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <LabelComponent setProjectName={setProjectName} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/project/:userName/:projectName/segment/:index"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <SegmentComponent setProjectName={setProjectName} />
              </ProtectedRoute>
            }
          />
            <Route
            path="/project/:userName/:projectName/ocr/:index"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <OCRComponent setProjectName={setProjectName} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-project/:userName"
            element={
              <ProtectedRoute allowedRoles={["admin", "user"]}>
                <AllProjects />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
